import {Injectable} from "@angular/core";
import {ApiService} from "../../../services/api.service";

@Injectable()
export class ResetPasswordService {

  contextApi = '/api';

  constructor(private apiService: ApiService) {
  }

  public resetPasswordEmail(
    username: string,
    email: string,
    phoneNumber: string,
    contactChannel: string
  ): any {
    return this.apiService.putCall(
      this.contextApi + '/public/reset-password/send-reset-password-email',
      {
        username: email,
        email: email,
        phoneNumber: phoneNumber,
        contactChannel: contactChannel
      },
      false,
      false,
      true
    )
  }

  public resetPassword(
    secureCodeId: number,
    secureCode: string,
    resetPassword: string
  ): any {
    return this.apiService.putCall(
      this.contextApi + '/public/reset-password/reset',
      {
        secureCodeId: secureCodeId,
        secureCode: secureCode,
        resetPassword: resetPassword
      },
      false,
      false,
      true
    )
  }

}
